import { Component, Input } from '@angular/core';
import { FormGroupDirective, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Global } from '../../../shared/global';
import { IWeiterePerson } from '../../models/weitereperson';
import { DateService } from '../../service/date.service';

@Component({
  selector: 'app-haftpflicht-personen',
  templateUrl: './haftpflicht-personen.component.html',
  styleUrls: ['./haftpflicht-personen.component.scss']
})
export class HaftpflichtPersonenComponent {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  geburtsdatumMinDate = Global.GEBURTSDATUM_MIN_DATE;
  geburtsdatumMaxDate: Date;

  constructor(private dateService: DateService) {
    this.geburtsdatumMaxDate = this.dateService.today();
  }

  static createFormGroup(fb: UntypedFormBuilder): UntypedFormGroup {
    return fb.group({
      vorname: new UntypedFormControl('', Validators.required),
      nachname: new UntypedFormControl('', Validators.required),
      geburtsdatum: new UntypedFormControl('', Validators.required)
    });
  }

  get vorname() { return this.formGroup.get('vorname'); }
  get nachname() { return this.formGroup.get('nachname'); }
  get geburtsdatum() { return this.formGroup.get('geburtsdatum'); }

  setHaftpflichtPerson(weiterePerson: IWeiterePerson) {
    this.vorname.setValue(weiterePerson.Vorname);
    this.nachname.setValue(weiterePerson.Nachname);
    this.geburtsdatum.setValue(moment(weiterePerson.Geburtsdatum));
  }

  getHaftpflichtPerson(): IWeiterePerson {
    return {
      Vorname: this.vorname.value,
      Nachname: this.nachname.value,
      Geburtsdatum: this.geburtsdatum.value
    };
  }
}
